var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "table-responsive" }, [
      _c("table", { staticClass: "table table-striped" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "tbody",
          [
            _vm.loading
              ? _c("tr", [
                  _c(
                    "td",
                    { staticClass: "text-center", attrs: { colspan: "7" } },
                    [_vm._v("Loading...")]
                  )
                ])
              : !_vm.emissions.data || _vm.emissions.data.length === 0
              ? _c("tr", [
                  _c(
                    "td",
                    { staticClass: "text-center", attrs: { colspan: "7" } },
                    [_vm._v("No emissions data found")]
                  )
                ])
              : _vm._l(_vm.emissions.data, function(emission) {
                  return _c(
                    "tr",
                    {
                      key: emission.id,
                      staticClass: "clickable-row",
                      on: {
                        click: function($event) {
                          return _vm.$emit("row-click", emission)
                        }
                      }
                    },
                    [
                      _c("td", [_vm._v(_vm._s(emission.chassis_number))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(emission.make))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(emission.model))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(emission.year))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(emission.class))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(emission.co2_3pwltp))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(emission.co2_difference_2025))]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(emission.industry_code))])
                    ]
                  )
                })
          ],
          2
        )
      ])
    ]),
    _vm._v(" "),
    _vm.emissions.last_page > 1
      ? _c("nav", [
          _c(
            "ul",
            { staticClass: "pagination" },
            [
              _c(
                "li",
                {
                  staticClass: "page-item",
                  class: { disabled: _vm.emissions.current_page <= 1 }
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "page-link",
                      on: {
                        click: function($event) {
                          return _vm.changePage(_vm.emissions.current_page - 1)
                        }
                      }
                    },
                    [_vm._v("Previous")]
                  )
                ]
              ),
              _vm._v(" "),
              _vm._l(_vm.visiblePages, function(page) {
                return _c(
                  "li",
                  {
                    key: page,
                    staticClass: "page-item",
                    class: { active: page === _vm.emissions.current_page }
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "page-link",
                        on: {
                          click: function($event) {
                            return _vm.changePage(page)
                          }
                        }
                      },
                      [_vm._v(_vm._s(page))]
                    )
                  ]
                )
              }),
              _vm._v(" "),
              _c(
                "li",
                {
                  staticClass: "page-item",
                  class: {
                    disabled:
                      _vm.emissions.current_page >= _vm.emissions.last_page
                  }
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "page-link",
                      on: {
                        click: function($event) {
                          return _vm.changePage(_vm.emissions.current_page + 1)
                        }
                      }
                    },
                    [_vm._v("Next")]
                  )
                ]
              )
            ],
            2
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Chassis Number")]),
        _vm._v(" "),
        _c("th", [_vm._v("Make")]),
        _vm._v(" "),
        _c("th", [_vm._v("Model")]),
        _vm._v(" "),
        _c("th", [_vm._v("Year")]),
        _vm._v(" "),
        _c("th", [_vm._v("Class")]),
        _vm._v(" "),
        _c("th", [_vm._v("CO₂ 3PWLTP")]),
        _vm._v(" "),
        _c("th", [_vm._v("CO₂ Difference (2025)")]),
        _vm._v(" "),
        _c("th", [_vm._v("Industry Code")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-04385f26", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04385f26","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Co2Emissions/DataTable.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-04385f26","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Co2Emissions/DataTable.vue
// module chunks = 0